import { Col, List, Row } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { Empty } from 'src/components/Empty/Empty';
import { LoanApplicationStatusView } from 'src/components/LoanApplicationStatusView/LoanApplicationStatusView';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { Router } from 'src/core/router/Router';
import { LoanApplicationDto } from 'src/generated-api-client';
import { LoanApplicationsStore } from 'src/stores/LoanApplicationsStore/LoanApplicationsStore';
import styled from 'styled-components';

const store = LoanApplicationsStore;

export const PartnerApplicationsTab = observer(() => {
    const {
        params: { id },
    } = useRouteMatch<{ id: string }>();

    useEffect(() => {
        if (id) {
            store.filterCriteria.setFilter({
                filterPartnerId: id,
            });
            store.loadList();
        }

        return () => {
            store.filterCriteria.resetFilter();
            store.listLoader.reset();
        };
    }, []);

    return (
        <StyledList
            dataSource={store.list}
            locale={{
                emptyText: (
                    <Empty
                        description={t('Partner.Applications.NoApplications')}
                    />
                ),
            }}
            renderItem={(item) => {
                const application = item as unknown as LoanApplicationDto;

                return (
                    <Card
                        key={application.id}
                        onClick={() => {
                            const path =
                                application.id !== undefined
                                    ? EntityLinks.loanApplications.itemDetails?.(
                                          application.id,
                                      )
                                    : undefined;

                            if (path) {
                                Router.navigate(path);
                            }
                        }}
                    >
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={5}>
                                <DataView
                                    label={t(
                                        'Partner.Applications.ApplicationID',
                                    )}
                                    value={application.number}
                                />
                            </Col>
                            <Col xs={24} sm={5}>
                                <DataView
                                    label={t(
                                        'Partner.Applications.MerchantName',
                                    )}
                                    value={application.merchant?.name}
                                />
                            </Col>
                            <Col xs={24} sm={5}>
                                <DataView
                                    label={t(
                                        'Partner.Applications.CreationDate',
                                    )}
                                    value={application.createdAt}
                                    formatValue="dateTimeSeconds"
                                />
                            </Col>
                            <Col xs={24} sm={5}>
                                <DataView
                                    label={t('Partner.Applications.Status')}
                                    value={
                                        application.status ? (
                                            <LoanApplicationStatusView
                                                status={application.status}
                                            />
                                        ) : undefined
                                    }
                                />
                            </Col>
                            <Col xs={24} sm={4}>
                                <DataView
                                    label={t('Partner.Applications.Amount')}
                                    value={
                                        application.finalOffer?.financingAmount
                                    }
                                    formatValue="currency-sar"
                                />
                            </Col>
                        </Row>
                    </Card>
                );
            }}
        />
    );
});

const StyledList = styled(List)`
    margin-left: 0 !important;
`;
